import { useState, useEffect, useCallback } from 'react';
import { formatRelativeTime } from '@/utils/date';
import { MILLISECONDS_TO_SECONDS } from '@/constants/time';

interface UseLastUpdatedReturn {
    lastUpdated: number | null;
    timeAgo: string;
    updateTimestamp: () => void;
}

export function useLastUpdated(dataLoaded: boolean): UseLastUpdatedReturn {
    const [lastUpdated, setLastUpdated] = useState<number | null>(null);
    const [timeAgo, setTimeAgo] = useState<string>('');

    const updateTimestamp = useCallback(() => {
        const now = Date.now();
        setLastUpdated(now);
        const timestampInSeconds = Math.floor(now / MILLISECONDS_TO_SECONDS);
        setTimeAgo(formatRelativeTime(timestampInSeconds));
    }, []);

    useEffect(() => {
        if (dataLoaded && lastUpdated === null) {
            updateTimestamp();
        }
    }, [dataLoaded, lastUpdated, updateTimestamp]);

    return {
        lastUpdated,
        timeAgo,
        updateTimestamp,
    };
}
